<template>
  <v-expansion-panels class="px-0" style="position: relative;" :value="opened">
    <v-expansion-panel class="mb-1">
      <v-expansion-panel-header
        color="secondary darken-2 white--text"
      >
        FAVORITES
        <template v-slot:actions>
          <v-icon color="white">
            $expand
          </v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="overflow-y grey lighten-4" style="height: 375px;">
        <slot></slot>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  export default {
    name: 'FavoritesPanel',

    props: {
      item: { type: Array }
    },

    data () {
      return {
        opened: 0
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>